import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import UserSubs from './UserSubs';
import QuickNewUserSubLink from 'components/NewUserSubLink/quick';

import { fetchUserFilteredSubs } from 'actions/quickSubs';
import { getFilteredQuickSubs, getPageCount } from 'reducers';
import {
  quickSubQueryObjectMap,
  quickMapCountToFilter,
  quickSubsRequestButtonName,
} from 'helpers/subsCountQueries';

const mapStateToProps = (state, { isReseller, location }) => {
  const { quickSubsFilter = 'quick_active', quickSubsPage = '1' } = qs.parse(
    location.search,
    { ignoreQueryPrefix: true },
  );
  const subs = getFilteredQuickSubs(state, quickSubsFilter, quickSubsPage);

  return {
    subs,
    isReseller,
    subFilter: quickSubsFilter,
    page: quickSubsPage,
    paginationKey: 'quickSubsPage',
    filterKey: 'quickSubsFilter',
    subQueryMap: quickSubQueryObjectMap,
    filterToCountMap: quickMapCountToFilter,
    pageCount: getPageCount(
      state,
      'quickSubs',
      `${quickSubsFilter}Subs`,
      quickSubsPage,
    ),
    heading: 'Quick Subscriptions',
    viewUrl: (sub) => `/quick/subscriptions/${sub.id}/view`,
    tabFilters: quickSubsRequestButtonName,
    wrapperId: 'quick-subs',
    NewUserSubLink: QuickNewUserSubLink,
    carrier: 'quick',
  };
};

const mapDispatchToProps = {
  fetchUserFilteredSubs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserSubs),
);
